import { Form } from "antd";
import {
  forwardRef,
  ReactElement,
  ReactNode,
  Ref,
  useEffect,
  useImperativeHandle,
} from "react";

interface Props<T> {
  data?: T;
  children?: ReactNode;
  onFinish?: (values: T) => void;
  onModify?: () => void;
}

export interface DataInspectorRef<T> {
  reset: () => void;
  submit: () => void;
}

const DataInspector = forwardRef(InnerDataInspector) as <T>(
  props: Props<T> & { ref: Ref<DataInspectorRef<T>> }
) => ReactElement;

export default DataInspector;

function InnerDataInspector<T>(
  { data, children, onFinish, onModify }: Props<T>,
  ref: Ref<DataInspectorRef<T>>
) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(data);
  }, [data]);

  useImperativeHandle(ref, () => {
    return {
      reset: form.resetFields,
      submit: form.submit,
    };
  });

  return (
    <Form<T>
      form={form}
      labelAlign="left"
      labelCol={{ span: 6 }}
      onFinish={onFinish}
      onValuesChange={() => {
        if (form.isFieldsTouched()) onModify?.();
      }}
    >
      {children}
    </Form>
  );
}
